module.exports = __webpack_public_path__ + "img/ppt.b363967e.svg";